export type Accrual = {
  id: number | null
  date: string | null
  supplier: string | null
  accrual_type: string | null
  accrual_expense_is_account: string | null
  amount: number | string | null
  description: string | null
  bs_account: string | null
  department: string | null
  is_posted?: boolean
}

export type AccrualPayload = {
  id: number | null
  date: string
  supplier: string
  accrual_type: string
  accrual_expense_is_account: string
  amount: string
  description: string
  bs_account: string
  department: string
}

export type PostingStatus = {
  unposted?: number
  unpostedAccruals?: number
  unpostedBankStatements?: number
  unpostedSchedules?: number
  /**
   * Per-schedule-type breakdown - each Depreciation / Prepaid / Loan page
   * reads only its own count from here so the banner doesn't lump every
   * schedule type into a misleading shared total.
   */
  unpostedSchedulesByType?: {
    depreciation?: number
    prepaid?: number
    loan?: number
  }
  unpostedJournalEntries?: number
  unpostedInvoices?: number
  unpostedBills?: number
  blocked?: number
  blockedBankStatements?: number
  blockedSchedules?: number
  [key: string]: unknown
}

export const ACCRUAL_TYPES: { code: string; label: string }[] = [
  { code: 'Accrued Expenses (Prof. Services)', label: 'Professional services' },
  { code: 'Accrued Interests', label: 'Interest accruals' },
  { code: 'Accrued Salaries', label: 'Salaries & wages' },
  { code: 'Accrued Taxes', label: 'Tax accruals' },
  { code: 'Accrued Rent', label: 'Rent' },
  { code: 'Accrued Utilities', label: 'Utilities' },
  { code: 'Other Accrual', label: 'Other' },
]

/** Expense code → suggested liability B/S code (legacy mapping). */
export const BS_SUGGESTIONS: Record<string, string> = {
  '6016': '2101',
  '6023': '2101',
  '6028': '2102',
  '6033': '2103',
  '6316': '2134',
  '7006': '2134',
  '7110': '2141',
}
